/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailCleanupResult
 */
export interface EmailCleanupResult {
    /**
     * 
     * @type {number}
     * @memberof EmailCleanupResult
     */
    deletedCount?: number;
}

/**
 * Check if a given object implements the EmailCleanupResult interface.
 */
export function instanceOfEmailCleanupResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmailCleanupResultFromJSON(json: any): EmailCleanupResult {
    return EmailCleanupResultFromJSONTyped(json, false);
}

export function EmailCleanupResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailCleanupResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deletedCount': !exists(json, 'deletedCount') ? undefined : json['deletedCount'],
    };
}

export function EmailCleanupResultToJSON(value?: EmailCleanupResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deletedCount': value.deletedCount,
    };
}

